<template>
<!-- 20220511髙森作成ファイル -->
  <el-form-item
    :label="label"
    class="billing-exclusion-flag"
    :prop="prop"
    :rules="rules"
  >
    <el-select
      v-model="date"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :clearable="clearable"
      :filterable="false"
      :filter-method="filter"
    >
      <!-- <el-option label="" value="" /> -->
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
        <span style="float: left">{{item.label}}</span>
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '請求除外'
    },
    prop: {
      type: String,
      default: 'billing_exclusion_flag'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    codeId: {
      type: String,
      default: 'BILLING_EXCLUSION'
    }
  },
  data () {
    return {
      options: [],
      optionsOriginal: []
    }
  },
  computed: {
    date: {
      get () {
        return this.value
      },
      set (date) {
        this.$emit('change', date)
        this.options = this.optionsOriginal
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  async mounted () {
    await this.loadCode()
    this.setOption()
    // const billingExclusionFlag = await this.loadCode()
    // const billingExclusionFlagSet = billingExclusionFlag.map(function (index, array) {
    //   return { value: index.code_value, label: index.code_explanation }
    // })
    // this.options = billingExclusionFlagSet
    // this.optionsOriginal = billingExclusionFlagSet
  },
  watch: {
    codeId: function () {
      this.setOption()
    }
  },
  methods: {
    setOption () {
      const billingExclusionFlag = JSON.parse(sessionStorage.getItem(this.codeId))
      const billingExclusionFlagSet = billingExclusionFlag.map(function (index, array) {
        return { value: index.code_value, label: index.code_explanation }
      })
      this.options = billingExclusionFlagSet
      this.optionsOriginal = billingExclusionFlagSet
    },
    async loadCode () {
      if (this.initialize) {
        const keyCodeArr = 'BILLING_EXCLUSION_ARR'
        await this.$axios
          .get('/code-master', { params: { code_id: keyCodeArr } })
          .then((res) => {
            sessionStorage.setItem(keyCodeArr, JSON.stringify(res.data.list))
          })
          .catch((e) => {
            console.log(e)
          })
        const keyCodeDep = 'BILLING_EXCLUSION_DEP'
        await this.$axios
          .get('/code-master', { params: { code_id: keyCodeDep } })
          .then((res) => {
            sessionStorage.setItem(keyCodeDep, JSON.stringify(res.data.list))
          })
          .catch((e) => {
            console.log(e)
          })
      }
      // return JSON.parse(sessionStorage.getItem(this.codeId))
    },
    filter (a) {
      this.options = this.optionsOriginal.filter((x) => {
        return x.value.toLowerCase().indexOf(a.toLowerCase()) === 0 || x.label.toLowerCase().indexOf(a.toLowerCase()) === 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.date {
  ::v-deep .el-form-item__content {
    width: 8em;
  }
}
.el-select-dropdown__item span {
  padding-left: 5px;
  padding-right: 5px;
}
</style>
